export default __webpack_public_path__ + "static/media/table_placeholder.f234443a.svg";